import React from "react";
import { Link } from "react-router-dom";

import { usePaymentModal } from "contexts/PaymentModalContext.jsx";
import { useStateSelector } from "utils/field";

import { getRangeForFilters } from "utils/payment/helpers";

import { default as MultiSelect } from "components/Input/MultiSelect";
import Select from "components/Input/Select";
import Button from "components/Button";

import classes from "./styles.module.scss";

import FilterIcon from "assets/images/icons/Filter.svg";
import CreditsPurchased from "assets/images/icons/creditsPurchased.svg";
import CreditsIn from "assets/images/icons/creditsIn.svg";
import CreditsOut from "assets/images/icons/creditsOut.svg";
import creditsInsights from "assets/images/icons/creditsInsights.svg";
import creditsParametric from "assets/images/icons/creditsParametric.svg";
import { VoltaBlueSmallLogo } from "~assets/images/icons/JSX/VoltaSmallBlueLogo";

const FILTER_OPTIONS = [
    { value: "PURCHASED", label: "Purchased", image: CreditsPurchased },
    { value: "TRANSFER_IN", label: "Credits In", image: CreditsIn },
    { value: "TRANSFER_OUT", label: "Credits Out", image: CreditsOut },
    { value: "SPENT.INSIGHTS", label: "Insights", image: creditsInsights },
    { value: "SPENT.PARAMETRIC", label: "Parametric", image: creditsParametric },
];

const DATE_RANGE_OPTIONS = [
    { value: "today", label: "Today" },
    { value: "thisWeek", label: "This Week" },
    { value: "last7Days", label: "Last 7 Days" },
    { value: "thisMonth", label: "This Month" },
    { value: "last30Days", label: "Last 30 Days" },
    { value: "allTime", label: "All Time" },
    { value: "custom", label: "Custom" },
];

const Filters = ({ filters, setFilters, setLastId }) => {
    const { dispatch } = usePaymentModal();
    const isUserVerified = useStateSelector("user.isUserVerified");

    const selectDateRange = (value, dataRange) => {
        const dataRangeToSet =
            value === "custom"
                ? { start: dataRange.start, end: dataRange.end }
                : getRangeForFilters(value, { start: null, end: null });

        setFilters({
            dateRange: { valueForDropdown: value, start: dataRangeToSet.start, end: dataRangeToSet.end },
        });

        setLastId(null); // Reset lastId when date range changes
    };

    return (
        <div className={classes.filtersContainer}>
            <div className={classes.filtersWrapper}>
                <img src={FilterIcon} alt="Filter Icon" />
                <MultiSelect
                    className={classes.filterSelect}
                    options={FILTER_OPTIONS}
                    forcedLabel={true}
                    customLabel={<span className={classes.placeholder}>Transaction Type</span>}
                    labelWithImages={true}
                    images={FILTER_OPTIONS.map((option) => option.image)}
                    input={{
                        value: filters.type,
                        onChange: (val) => {
                            setFilters({ type: val });
                        },
                    }}
                    dropdownClassName={classes.dropdown}
                />
                <Select
                    className={classes.filterSelect}
                    customStyles={{ minWidth: "200px" }}
                    options={DATE_RANGE_OPTIONS}
                    forcedLabel={true}
                    customLabel={<span className={classes.placeholder}>Date Range</span>}
                    input={{
                        value: filters.dateRange.valueForDropdown,
                        onChange: (val) => {
                            selectDateRange(val);
                        },
                    }}
                    displaySelectedValue={true}
                    dropdownClassName={classes.dropdown}
                    isDatePicker={true}
                    range={{ start: filters.dateRange.start, end: filters.dateRange.end }}
                    selectDateRange={(value, dataRange) => {
                        selectDateRange(value, dataRange);
                    }}
                />
                <Button
                    type={"lightGrey"}
                    small
                    style={{ background: "none" }}
                    onClick={() => {
                        setFilters({
                            type: ["PURCHASED", "TRANSFER_IN", "TRANSFER_OUT", "SPENT.INSIGHTS", "SPENT.PARAMETRIC"],
                            dateRange: {
                                valueForDropdown: "allTime",
                                start: null,
                                end: null,
                            },
                            sortBy: {
                                value: "time",
                                label: "Time",
                            },
                        });
                    }}
                >
                    Clear
                </Button>
            </div>
            <div className={classes.actions}>
                <Link to="/pricing" className={classes.pricingLink}>
                    View pricing
                </Link>
                <Button
                    onClick={() => dispatch({ type: "OPEN" })}
                    icon={() => <VoltaBlueSmallLogo fill="#fff" />}
                    small
                    disabled={!isUserVerified}
                >
                    Buy Credits
                </Button>
            </div>
        </div>
    );
};

export default Filters;
